import React from "react";

import { ErrorPage } from "./ErrorPage";
import { Sidebar } from "./Sidebar";

export const FeatureNotAvailable = () => (
    <ErrorPage
        title="Feature unavailable"
        message="Please contact support@formant.io to enable this feature"
        reload={false}
        logout={false}
        back={true}
        menu={<Sidebar key="sidebar" />}
    />
);
